var map = {
	"./1.png": 107,
	"./2.png": 66,
	"./3.png": 67,
	"./4.png": 68,
	"./5.png": 69,
	"./beian.png": 72,
	"./sanguo-1.png": 50,
	"./sanguo-2.png": 51,
	"./sanguo-3.png": 52,
	"./sanguo-4.png": 53,
	"./sanguo-5.png": 54,
	"./sanguo-6.png": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;